import "@/assets/style.css";
import "./service-worker.js";
import App from "./App.vue";
import { createApp } from "vue";
import { createPinia } from "pinia";
import { useUsersStore } from "./stores/v2";
import router from "./router/v2";
import QueueService from "./services/v2/queue";
import { createHead } from "@vueuse/head";
import ItemDropdown from "@/components/v2/UI/ItemDropdown.vue";

const app = createApp(App);
const pinia = createPinia();
const head = createHead()

// Register global components
app.component('ItemDropdown', ItemDropdown);

app.use(pinia);
app.use(head);
app.use(router);

useUsersStore().setFromLocalStorage();
QueueService.setupNetworkListeners();

app.config.globalProperties.$store = pinia;

app.mount("#app");
